import SideBar from './SideBar';
import DatePicker from 'react-datepicker';
import storage from '../services/storage';
import { gitClassDetails, classDetailss } from '../Store/api/classApi';
import { createClassAuth, getUserDetails } from '../Store/api/auth';
import classDetailsValiation from '../ValidationScheema/ClassDetails';
import 'react-datepicker/dist/react-datepicker.css';
import classSchema from '../ValidationScheema/ClassSchema';
import { Modal, ModalBody } from 'react-bootstrap';
import edit from '../../src/assets/images/edit.svg';
import delet from '../../src/assets/images/trash-2.svg';
import help from '../../src/assets/images/help-circle.svg';
import tick from '../../src/assets/images/tickmark.svg';
import goBack from '../../src/assets/images/model/goback.svg';
import cross from '../../src/assets/images/cross.svg';
import plus from '../../src/assets/images/pluse.png';
import link from '../../src/assets/images/linke.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import { setSiteMode, resetSiteMode } from '../Store/settings/siteSettings';
import { me } from '../Store/api/auth';
import { Formik, useFormik, ErrorMessage, FieldArray, Field } from 'formik';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DraggableSidebar from '../components/DraggableSidebar';
import Loader from '../components/Loader';
import { baseUrl } from '../configs';
import {
  classInfo,
  classInfoUpdate,
  createClassStartAssigning,
  classInfoById,
  gitEmails,
} from '../Store/api/classApi';
import { sectionUpdate, teacherAssitantEmail } from '../Store/api/sectionUpdate';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { deleteSection } from '../Store/api/sectionDelete';
import { removeSection } from '../Store/entities/classInfoById';
import { deleteSectionsidebar } from '../Store/entities/createClass';
import RightsidebarGreybox from '../components/RightsidebarGreybox';

const getInitialTab = () => {
  const savedTab = localStorage.getItem('activeClassTab');
  const parsedTab = savedTab !== 'undefined' ? parseInt(savedTab, 10) : 0;
  return isNaN(parsedTab) ? 0 : parsedTab;
};

const CreateClass = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [params] = useSearchParams();
  const bookId = params.get('bookId');
  const backTo = params.get('back_to') ?? '';

  //Create new section States
  const [id2, setId2] = useState('');
  const [day, setDays] = useState('');
  const [edit, setEdit] = useState(false);
  const [show, setShow] = useState(false);
  const [endDate, setEndDate] = useState();
  const [message, setMessage] = useState([]);
  const [classTab, setClassTab] = useState(getInitialTab);
  const [startDate, setStartDate] = useState();
  const [loading, setLoading] = useState(false);
  const [updated, setUpdated] = useState(message);
  const [maxClassTab, setMaxClassTab] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [createLink, setCreateLink] = useState(true);
  const [schedule, setSchedule] = useState('Schedule');
  const [sectionsList, setSectionsList] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [clipboardState, setClipboardState] = useState('');
  const [currentSection, setCurrentSection] = useState({});
  const [showEamailSearch, setShowEamailSearch] = useState(null);
  const classes = useSelector((state) => state.entities.classes);
  const userInfo = useSelector((state) => state?.entities?.auth?.user) || [];
  const [classDetailsValues] = useState({
    sectionName: '',
    sectionNumber: '',
    instructorFirstName: '',
    instructorLastName: '',
    instructorEmails: [''],
  });
  const [initialValues2, setInitialValues] = useState({
    courseNumber: '',
    courseName: '',
    startDate: '',
    endDate: '',
    schedule: '',
  });
  const storeUser = storage.get('user');
  const [creatSection, setCreatSection] = useState(true);
  const onClicks = (value1) => setCreatSection(value1);

  const [errorMessage, setErrorMessage] = useState({
    type: 'success',
    message: '',
  });

  const [errorMessage1, setErrorMessage1] = useState({
    type: 'success',
    message: '',
  });

  const handleClose = () => {
    setModalShow(false);
  };
  const handleShowDialoguebox = () => {
    const lastClass = classes?.classes?.[classes.classes.length - 1];

    if (lastClass && lastClass.sections?.length < 1) {
      setModalShow(true);
    }
  };

  useEffect(() => {
    const classList = classes?.classes;
    if (classList && classList.length > 0 && !id2) {
      const lastClass = classList[classList.length - 1];
      if (lastClass?._id) {
        setId2(lastClass._id);
      }
    }
  }, [classes?.classes, id2]);

  const classDetails = useSelector((state) => state.entities.classDetails);
  const emails = useSelector((state) => state.entities.instructors.instructors) || [];
  const emailsMap = {};
  for (const email of emails) {
    emailsMap[email.email] = email;
  }

  const user = useSelector((state) => state.entities.updateClassInfo.updateClassInfo);
  const { sections = [] } = useSelector((state) => state.entities.classInfoById);
  const { pathname, search = '' } = useLocation();

  const handler = (e) => {
    e.preventDefault();

    if (classTab === 0) navigate(-1);
    else {
      window.history.pushState(null, null, `${pathname}${search}`);
      setClassTab((prev) => prev - 1);
    }
  };

  useEffect(() => {
    window.history.pushState(null, null, `${pathname}${search}`);
    window.addEventListener('popstate', handler);

    return () => {
      window.removeEventListener('popstate', handler);
    };
  }, [classTab]);

  useEffect(() => {
    dispatch(gitEmails({}));
  }, []);

  useEffect(() => {
    if (id2) {
      dispatch(
        classInfoById({
          id: id2,
          onSuccess: (res) => {},
          onError: (err) => {
            setErrorMessage({
              type: 'danger',
              message: err.response ? err.response.data.message : err.message,
            });
          },
        })
      );
    }
    dispatch(me({ onSuccess: (res) => {}, onError: (err) => {} }));
  }, [classes, classDetails, id2, dispatch]);

  useEffect(() => {
    if (classTab > maxClassTab) {
      setMaxClassTab(classTab);
    }
  }, [classTab, maxClassTab]);
  // For Update Class
  useEffect(() => {
    const {
      courseNumber = '',
      courseName = '',
      startDate = '',
      endDate = '',
      schedule = '',
    } = user;

    const data = {
      courseNumber,
      courseName,
      startDate,
      endDate,
      schedule,
    };
    if (data.startDate) setStartDate(new Date(data.startDate));
    if (data.endDate) setEndDate(new Date(data.endDate));
    // setSchedule(data.schedule);
    setInitialValues(data);
  }, []);

  // This for Update Logo
  useEffect(() => {
    dispatch(setSiteMode('prof'));
    return () => {
      dispatch(resetSiteMode());
    };
  }, []);

  const oneWeekFromNow = new Date(startDate);
  oneWeekFromNow.setDate(oneWeekFromNow.getDate() + 1);

  const { values, errors, touched, handleBlur, handleSubmit, handleChange } = useFormik({
    initialValues: initialValues2,
    validationSchema: classSchema,
    enableReinitialize: true,

    onSubmit: (values, action) => {
      setLoading(true);

      dispatch(
        createClassAuth({
          body: {
            ...(edit && id2 ? { classId: id2 } : {}),
            ...(bookId && { bookId }),
            courseNumber: values.courseNumber,
            courseName: values.courseName,
            startDate: startDate,
            endDate: endDate,
            schedule: message.join(','),
          },
          onSuccess: (res) => {
            const newId = res?.data?.data?._id;
            setEdit(false);
            setId2(newId);
            setLoading(false);
            localStorage.setItem('activeClassTab', 1);
            classTab === 0 ? setClassTab(1) : setClassTab(0);
            dispatch(
              classInfo({
                onSuccess: () => {},
              })
            );
            dispatch(
              gitClassDetails({
                onSuccess: () => {},
              })
            );
          },

          onError: (err) => {
            setLoading(false);
            setErrorMessage({
              type: 'danger',
              message: err.response.data.message,
            });
          },
        })
      );
      dispatch(
        getUserDetails({
          userId: storeUser._id,
          onSuccess: () => {},
          onError: () => {},
          onEnd: () => {},
        })
      );
    },
  });

  useEffect(() => {
    storage.get('xAuthToken');
  }, [classes, classDetails]);
  useEffect(() => {
    const token = storage.get('xAuthToken');
    localStorage.getItem('class');
    if (token) {
      dispatch(
        gitClassDetails({
          onSuccess: (res) => {},
        })
      );
    }
  }, []);

  // Formik for Class Details
  const onSubmit = (values, action) => {
    setLoading(true);
    dispatch(
      classDetailss({
        body: {
          sectionName: values.sectionName,
          sectionNumber: values.sectionNumber,
          instructorEmails: values.instructorEmails.filter((email) => !!email),
          classId: id2,
        },

        onSuccess: () => {
          setCreatSection(false);
          setErrorMessage1({
            type: 'success',
            message: '',
          });
          setLoading(false);
          dispatch(
            gitClassDetails({
              onSuccess: () => {
                setSectionsList((prev) => [...prev, currentSection]);
                setCurrentSection({});
              },
            })
          );

          localStorage.removeItem('class');
          action.resetForm();
          dispatch(
            classInfo({
              onSuccess: () => {},
            })
          );
        },

        onError: (err) => {
          setLoading(false);
          setErrorMessage1({
            type: 'danger',
            message: err.response ? err.response.data.message : err.message,
          });
        },
      })
    );
  };

  const setClass = (e, tabIndex) => {
    e.preventDefault();
    setClassTab(tabIndex);
    localStorage.setItem('activeClassTab', tabIndex);
  };

  const handleClick = () => {
    // 👇 "message" stores input field value
    setUpdated(message);
  };
  const handleChang = (event) => {
    if (!message.includes(event.target.value)) {
      setDays('');
      setSchedule('');
      setMessage([...message, event.target.value]);
    } else {
      setMessage(message.filter((e) => e !== event.target.value));
    }
  };

  return (
    <div className='flex-container' style={{ overflowY: 'clip' }}>
      {classTab === '0' ? (
        <div
          // className="col-xxl-1 col-xl-1 col-lg-12 col-md-12 px-0"
          className='activity-spectrum'
          style={{ opacity: '.45' }}
        >
          <div>
            <DraggableSidebar setScrollToId={() => {}} />
          </div>
        </div>
      ) : (
        <div
          // className="col-xxl-1 col-xl-1 col-lg-12 col-md-12 px-0"
          className='activity-spectrum'
        >
          <div>
            <DraggableSidebar setScrollToId={() => {}} />
          </div>
        </div>
      )}

      <div className='w-100'>
        {' '}
        <section className='class_room_wrap sidebar-height'>
          <div className='custom_container sidebar-height' style={{ padding: '0px' }}>
            <div className='row' style={{ '--bs-gutter-x': '0', '--bs-gutter-y': '0' }}>
              <div className='col-xxl-3 col-xl-3 col-lg-4 col-md-12 px-0 pb-0 cursor_default'>
                <SideBar
                  handleShowDialoguebox={handleShowDialoguebox}
                  modalShow={modalShow}
                  mode='explore'
                  tabContents='class'
                  values={{
                    ...values,
                    startDate,
                    endDate,
                    schedule: message,
                    sections: sectionsList,
                    currentSection,
                  }}
                />
              </div>
              <div className='col-xxl-9 col-xl-9 col-lg-8'>
                <div className='welcome_wrap custom_nav pr-50 pt-16 '>
                  <ul
                    className='nav nav-tabs nav-justified create_class-width'
                    id='myTab'
                    role='tablist'
                  >
                    <li className='nav-item' role='presentation'>
                      <button
                        className={classTab === 0 ? 'nav-link active' : 'nav-link'}
                        // className="nav-link active"
                        id='home-tab'
                        data-bs-toggle='tab'
                        data-bs-target='#class-info'
                        type='button'
                        role='tab'
                        aria-controls='class-info'
                        aria-selected='true'
                        //  onClick={(e) =>backToTab(e)}
                        style={{
                          pointerEvents: maxClassTab >= 0 ? 'initial' : '',
                        }}
                        onClick={(e) => {
                          // if (classTab === 0) return;
                          // maxClassTab >= 0 && setClass(e, 0);
                        }}
                      >
                        class info
                      </button>
                    </li>
                    <li className='nav-item' role='presentation'>
                      <button
                        // className="nav-link active"
                        className={classTab === 1 ? 'nav-link active' : 'nav-link'}
                        id='class_details-tab'
                        data-bs-toggle='tab'
                        data-bs-target='#class_details'
                        type='button'
                        role='tab'
                        aria-controls='profile'
                        aria-selected='false'
                        style={{
                          pointerEvents: maxClassTab >= 1 ? 'initial' : '',
                        }}
                        // onClick={(e) => setClass(e, "classdetails")}
                        onClick={(e) => {
                          // if (!id2) return;

                          maxClassTab >= 1 && setClass(e, 1);
                        }}
                      >
                        class details
                      </button>
                    </li>
                    <li className='nav-item' role='presentation'>
                      <button
                        className={classTab === 2 ? 'nav-link active' : 'nav-link'}
                        // className="nav-link active"
                        id='add_students-tab'
                        data-bs-toggle='tab'
                        data-bs-target='#add_students'
                        type='button'
                        role='tab'
                        aria-controls='profile'
                        aria-selected='false'
                        // onClick={(e) =>backToTab(e)}
                        style={{
                          pointerEvents: maxClassTab >= 2 ? 'initial' : '',
                        }}
                        onClick={(e) => {
                          if (!id2) return;
                          maxClassTab >= 2 && setClass(e, 2);
                          // setClass(e, "classdetails");
                        }}
                      >
                        add students
                      </button>
                    </li>
                  </ul>
                  <div
                    className='tab-content cursor_default'
                    id='ClassInfo'
                    style={{
                      overflowY: 'scroll',
                      overflowX: 'clip',
                      height: '85%',
                    }}
                  >
                    <div
                      className={
                        classTab === 0 ? 'tab-pane fade show active' : 'tab-pane fade show '
                      }
                      id='class-info'
                      role='tabpanel'
                      aria-labelledby='class-info-tab'
                    >
                      <div className='row class_info_wrap'>
                        <div className='col-xl-12 col-lg-12'>
                          {' '}
                          <div className='' style={{ height: '80px' }}>
                            {''}
                          </div>
                          <h1 className='main_title  '>let’s create your class</h1>
                          <form className='create_class-width' onSubmit={handleSubmit}>
                            <div className='row '>
                              <div className='col-lg-4'>
                                <div
                                  className='form-group'
                                  style={{
                                    alignItems: 'baseline',
                                    width: '206px',

                                    position: 'relative',
                                  }}
                                >
                                  <div>
                                    <input
                                      style={{
                                        display: 'flex',
                                        width: '185px',
                                      }}
                                      type='text'
                                      className='form-control'
                                      placeholder='Course code'
                                      name='courseNumber'
                                      autoComplete='off'
                                      value={values.courseNumber}
                                      // onChange={handleChange}
                                      onChange={(e) => {
                                        if (e.target.value.length <= 16) {
                                          handleChange(e); // Only update the state if within limit
                                        }
                                      }}
                                      onBlur={handleBlur}
                                    />{' '}
                                    <img
                                      className='information-help'
                                      src={help}
                                      alt='help'
                                      style={{
                                        width: '16px',
                                        position: 'absolute',
                                        left: '175px',
                                        top: '19px',
                                      }}
                                    />
                                    <div
                                      className='tooltip_box'
                                      style={{
                                        left: '86px',
                                        top: '-47px',
                                        width: '194px',
                                        minHeight: '58px',
                                      }}
                                    >
                                      <div
                                        className='inner_wrap inner_class'
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'center',
                                        }}
                                      >
                                        <p className='theme_toltip text-white'>
                                          Ex. Spanish 101 --{'>'} SPN101
                                          <br />
                                          Max 10 characters
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='err-end'>
                                    {errors.courseNumber && touched.courseNumber ? (
                                      <p className='error-msg-3' style={{ marginTop: '-6%' }}>
                                        {errors.courseNumber}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                              <div className='col-lg-8'>
                                <div className='form-group'>
                                  <input
                                    type='text'
                                    className='form-control'
                                    placeholder='Course name'
                                    name='courseName'
                                    autoComplete='off'
                                    value={values.courseName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />{' '}
                                  <div className='err-end'>
                                    {errors.courseName && touched.courseName ? (
                                      <p className='error-msg-3'>{errors.courseName}</p>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                              <div className='col-lg-6'>
                                <div className='form-group'>
                                  {/* {startDate} */}
                                  <DatePicker
                                    placeholderText='Start Date'
                                    onChange={(e) => {
                                      setStartDate(e);
                                    }}
                                    className='form-control'
                                    name='startDate'
                                    value={startDate}
                                    selected={startDate}
                                    minDate={new Date()}
                                    autoComplete='off'
                                  />
                                </div>
                              </div>
                              <div className='col-lg-6'>
                                <div className='form-group'>
                                  <DatePicker
                                    placeholderText='End Date'
                                    onChange={(date) => setEndDate(date)}
                                    className='form-control'
                                    name='endDate'
                                    value={endDate}
                                    selected={endDate}
                                    minDate={oneWeekFromNow}
                                    autoComplete='off'
                                  />
                                </div>
                              </div>
                              <div className='col-lg-5 mt_30'>
                                <h6 className=' f_20'> Schedule</h6>
                                <h6 className=' f_30'>Choose the dates your class meets</h6>
                              </div>
                              <div className='col-lg-7 mt_30'>
                                <div className='Create-custom-schedule mb-0'>
                                  <input type='hidden' value={values.schedule} name='days' />
                                  <ul
                                    style={{
                                      width: '400px',
                                      fontWeight: '400',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    {['S', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'].map((day) => (
                                      <li className='option-schedule ' key={day}>
                                        <input
                                          style={{
                                            width: '40px',
                                            height: '40px',
                                          }}
                                          type='checkbox'
                                          value={`${day} `}
                                          id={day}
                                          checked={message.includes(`${day} `)}
                                          onChange={handleChang}
                                          className='custom-checkbox'
                                        />

                                        <label
                                          htmlFor={day}
                                          style={{
                                            fontSize: '18px',
                                            width: '40px',
                                            height: '40px',
                                            fontWeight: '400',
                                          }}
                                        >
                                          <span className='  title_1' onClick={handleClick}>
                                            {day}
                                          </span>
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                              <div></div>
                              <div className='col-lg-12' style={{ paddingTop: '64px' }}>
                                <div className='btn_Wrap'>
                                  <button type='submit' className='btn_black_theme w-100 d-block'>
                                    {loading ? (
                                      <div className='loader'>
                                        <Loader />
                                      </div>
                                    ) : (
                                      'Add class details'
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className='backend-error'>
                              {errorMessage.message && (
                                <div className={`alert alert-${errorMessage.type}`}>
                                  {errorMessage.message}
                                </div>
                              )}
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        classTab === 1 ? 'tab-pane fade show active' : 'tab-pane fade show '
                      }
                      id='class_details'
                      role='tabpanel'
                      aria-labelledby='class_details'
                    >
                      <div className='row class_info_wrap'>
                        <div className='col-lg-9d cursor_default'>
                          <div className='links_wrap d-flex justify-content-between create_class-width'>
                            <img
                              className='btn_link_step  ml-auto pt-45 cursor'
                              src={goBack}
                              alt='add later'
                              onClick={(e) => {
                                maxClassTab >= 0 && setClass(e, 0);
                                dispatch(
                                  classInfoUpdate({
                                    id: id2,
                                    onSuccess: (res) => {
                                      setEdit(true);
                                      const data = res.data.data;
                                      if (data.startDate) setStartDate(new Date(data.startDate));
                                      if (data.endDate) setEndDate(new Date(data.endDate));
                                      if (data.schedule) {
                                        setMessage(data.schedule.split(','));
                                        setSchedule(data.schedule);
                                      }
                                      // setSchedule(data.schedule);
                                      setInitialValues(data);
                                    },
                                  })
                                );
                              }}
                            />
                          </div>
                          <h1 className='main_title create_class-width '>
                            any sections or <br></br>instructors?
                          </h1>

                          <div className='add_btn_wrap create_class-width'>
                            {creatSection ? (
                              <div
                                className={`${
                                  sections.length > 0 ? `Schedule_box create_box` : 'section_box'
                                } `}
                                style={{
                                  position: 'relative',
                                }}
                              >
                                <Formik
                                  initialValues={classDetailsValues}
                                  validationSchema={classDetailsValiation}
                                  onSubmit={onSubmit}
                                >
                                  {({
                                    values,
                                    errors,
                                    setFieldValue,
                                    handleBlur,
                                    handleSubmit,
                                    handleChange,
                                  }) => {
                                    let selectedEmailsMap = {};
                                    for (const email of values.instructorEmails) {
                                      selectedEmailsMap[email] = true;
                                    }

                                    setCurrentSection(values);

                                    return (
                                      <>
                                        <div className='d-flex align-items-start justify-content-between'>
                                          {sections.length > 0 ? (
                                            <>
                                              <span className='create-new-sec text-grey'>
                                                Create new section
                                              </span>
                                              <img
                                                className='cursor'
                                                alt='cross ico'
                                                src={cross}
                                                onClick={() => {
                                                  setCreatSection(false);
                                                }}
                                              />
                                            </>
                                          ) : (
                                            <h6 className='text-grey-700'>Create new section</h6>
                                          )}
                                        </div>
                                        <form
                                          className='App-form create_class-width'
                                          onSubmit={handleSubmit}
                                        >
                                          <div className='row'>
                                            <div className='col-md-6'>
                                              <div className='form-group'>
                                                <input
                                                  type='text'
                                                  className='form-control'
                                                  placeholder='Section Name'
                                                  name='sectionName'
                                                  value={values.sectionName}
                                                  onChange={handleChange}
                                                  onBlur={handleBlur}
                                                  autoComplete='off'
                                                />{' '}
                                                <div className='err-end'>
                                                  <p className='error-msg'>
                                                    <ErrorMessage
                                                      className='error-msg'
                                                      name='sectionName'
                                                    />
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                            <div className='col-md-6'>
                                              <div className='form-group'>
                                                <input
                                                  type='text'
                                                  className='form-control'
                                                  placeholder='Section number'
                                                  name='sectionNumber'
                                                  value={values.sectionNumber}
                                                  onChange={handleChange}
                                                  onBlur={handleBlur}
                                                  autoComplete='off'
                                                />{' '}
                                                <div className='err-end'>
                                                  <p className='error-msg'>
                                                    <ErrorMessage
                                                      className='error-msg'
                                                      name='sectionNumber'
                                                    />
                                                  </p>
                                                </div>
                                              </div>
                                            </div>

                                            <div className='col-md-12'>
                                              <InstructorEmails
                                                values={values}
                                                errors={errors}
                                                emails={emails}
                                                emailsMap={emailsMap}
                                                setFieldValue={setFieldValue}
                                                errorMessage1={errorMessage1}
                                                showEamailSearch={showEamailSearch}
                                                setShowEamailSearch={setShowEamailSearch}
                                                selectedEmailsMap={selectedEmailsMap}
                                              />
                                              <div className='btn_Wrap mt-30'>
                                                <button
                                                  type='submit'
                                                  className='btn_black_theme w-100 d-block'
                                                  disabled={loading ? true : false}
                                                >
                                                  {loading ? (
                                                    <div className='loader'>
                                                      <Loader />
                                                    </div>
                                                  ) : (
                                                    'Add section to class'
                                                  )}
                                                </button>
                                              </div>
                                            </div>
                                          </div>{' '}
                                        </form>
                                      </>
                                    );
                                  }}
                                </Formik>
                              </div>
                            ) : (
                              <button
                                className='btn_Add'
                                id='btn_Add'
                                type='button'
                                onClick={() => onClicks(true)}
                              >
                                Create new section{' '}
                                <img src={plus} alt='pluse' className='pluse_icon' />
                              </button>
                            )}
                          </div>
                          <div className='backend-error create_class-width'>
                            {errorMessage1.message && (
                              <div className={`alert alert-${errorMessage1.type}`}>
                                {errorMessage1.message}
                              </div>
                            )}
                          </div>

                          {loading ? (
                            <div></div>
                          ) : (
                            <>
                              {sections.length > 0 ? (
                                <>
                                  <h1
                                    className='create_class-width sec_heading  mt-30 mb-20'
                                    style={{ marginTop: '1px' }}
                                  >
                                    sections
                                  </h1>
                                  {sections.map((item) => (
                                    <SectionClass
                                      key={item._id}
                                      id2={id2}
                                      item={item}
                                      emailsMap={emailsMap}
                                      dispatch={dispatch}
                                      values={values}
                                      loading={loading}
                                      setLoading={setLoading}
                                      setCreatSection={setCreatSection}
                                      setShow={setShow}
                                      show={show}
                                      setCreateLink={setCreateLink}
                                    />
                                  ))}
                                </>
                              ) : (
                                ''
                              )}
                            </>
                          )}

                          {!creatSection && sections.length > 0 && createLink && (
                            <div className='col-lg-12 create_class-width'>
                              <div className='btn_Wrap' style={{ margin: '64px 0 100px' }}>
                                <button
                                  type='button'
                                  className='btn_black_theme w-100 d-block'
                                  onClick={() => {
                                    dispatch(
                                      teacherAssitantEmail({
                                        id: id2,
                                        body: {
                                          sectionIds: sections.map((item) => item._id),
                                        },
                                        onSuccess: (res) => {
                                          localStorage.setItem('activeClassTab', 2);
                                        },
                                        onError: (err) => {
                                          toast.error(err.response.data.message);
                                        },
                                      })
                                    );
                                    setClassTab(2);
                                  }}
                                >
                                  Create classroom link
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      className={
                        classTab === 2 ? 'tab-pane fade show active' : 'tab-pane fade show '
                      }
                      id='add_students'
                      role='tabpanel'
                      aria-labelledby='add_students-tab'
                    >
                      <div className='row class_info_wrap '>
                        <div className='col-lg-9 '>
                          <div className='links_wrap d-flex justify-content-between'>
                            <a href='#see' className='btn_link_step   ml-auto pt-45 '>
                              {' <'}-- Go back
                            </a>{' '}
                          </div>

                          <h1 className='main_title  '>now add your students</h1>
                          <p
                            className='create_class-width theme_para '
                            style={{ marginTop: '16px', marginBottom: '40px' }}
                          >
                            Email your students the following link. They’ll automatically be added
                            to the class when they sign up for Greyled.
                          </p>
                          <div className='scroll_box_wrapper create_class-width'>
                            <div className='scroll_box'>
                              {storeUser?.status === 'validated' ? (
                                <>
                                  {sections.map((section) => (
                                    <div
                                      key={section._id}
                                      className='linke_copy_box linke_show-prof'
                                    >
                                      <h1 className='text_spn'>
                                        {section.sectionName} | Section{' '}
                                        {section.sectionNumber.split('-')[0]} |{' '}
                                        {section.instructorEmails &&
                                          section.instructorEmails.length > 0 && (
                                            <>
                                              <b>
                                                {(() => {
                                                  const first = section.instructorEmails[0];
                                                  const fullName = emailsMap[first.email]
                                                    ? `${emailsMap[first.email].firstName} ${
                                                        emailsMap[first.email].lastName
                                                      }`
                                                    : first.email.split('@')[0];

                                                  return fullName.length > 16
                                                    ? `${fullName.slice(0, 16)}...`
                                                    : fullName;
                                                })()}
                                              </b>
                                              {section.instructorEmails.length > 1 && (
                                                <b>
                                                  {' '}
                                                  +{section.instructorEmails.length - 1} instructor
                                                  {section.instructorEmails.length - 1 > 1
                                                    ? 's'
                                                    : ''}
                                                </b>
                                              )}
                                            </>
                                          )}
                                      </h1>
                                      <h2 className='theme_para'>
                                        {process.env.REACT_APP_ENV === 'development'
                                          ? baseUrl
                                          : baseUrl}
                                        section/{section.joinCode}
                                        {/*  <CopyToClipboard
                                      text={`${
                                        process.env.REACT_APP_ENV ===
                                        "development"
                                          ? "localhost:3000"
                                          : "https://app.greyled.work"
                                      }/section/${section.joinCode}`}
                                      onCopy={() =>
                                        setClipboardState(section._id)
                                      }>
                                      <a>
                                        {clipboardState === section._id && (
                                          <span style={{color: "black"}}>
                                            <br></br>copied
                                          </span>
                                        )}{" "}
                                        <img
                                          src="../assets/images/linke.png"
                                          alt="linke"
                                        />
                                      </a>
                                    </CopyToClipboard> */}
                                        <CopyToClipboard
                                          text={`${
                                            process.env.REACT_APP_ENV === 'development'
                                              ? baseUrl
                                              : baseUrl
                                          }section/${section.joinCode}`}
                                          onCopy={() => {
                                            setClipboardState(section._id);
                                            setShowTooltip(true); // Show tooltip after copying
                                          }}
                                        >
                                          <a>
                                            {clipboardState === section._id && (
                                              <span style={{ color: 'black' }}>copied</span>
                                            )}{' '}
                                            <img src={link} alt='linke' />
                                          </a>
                                        </CopyToClipboard>
                                      </h2>

                                      <div className='linke_copy_tooltip'>
                                        <div
                                          onMouseEnter={() => setShowTooltip(true)}
                                          onMouseLeave={() => setShowTooltip(false)}
                                        >
                                          <a className='copy_linke_text'>
                                            Copy link to clipboard
                                            {clipboardState === section._id && showTooltip && (
                                              <span style={{ color: 'black' }}>
                                                <div className='tooltip_box'>
                                                  <div className='inner_wrap'>
                                                    <p className='theme_para text-white'>
                                                      <b>Link copied -</b> Email it to <br /> your
                                                      students!
                                                    </p>
                                                  </div>
                                                </div>
                                              </span>
                                            )}
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </>
                              ) : (
                                <div className='linke_copy_box validate-prof'>
                                  Student invite link is temporarily hidden. You will gain access
                                  within 24 hours once our team has completed the professor
                                  validation process.
                                </div>
                              )}
                            </div>
                          </div>
                          <div className='col-lg-12 create_class-width'>
                            <div className='btn_Wrap mt-45 mb-100'>
                              <button
                                type='button'
                                className='btn_black_theme w-100 d-block'
                                onClick={() => {
                                  dispatch(
                                    getUserDetails({
                                      userId: storeUser._id,
                                      onSuccess: () => {},
                                      onError: () => {},
                                      onEnd: () => {},
                                    })
                                  );
                                  dispatch(
                                    createClassStartAssigning({
                                      id: id2,
                                      onSuccess: () => {
                                        localStorage.removeItem('activeClassTab');
                                        if (backTo === 'classes') navigate('/dashboard/classes');
                                        else if (bookId) navigate('/dashboard/bookshelf');
                                        else {
                                          navigate(`/assign/${storeUser?.isBookOpened}`);
                                          setTimeout(() => {
                                            window.location.reload(); // Only if necessary
                                          }, 100);
                                        }
                                      },
                                      onError: (err) => {
                                        toast.error(err.response.data.message);
                                      },
                                    })
                                  );
                                }}
                              >
                                Create class and start assigning
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='col-12 cursor_default'
                    style={{
                      position: 'absolute',
                      bottom: '38px',
                      width: '50%',
                    }}
                  >
                    <div
                      className='footer_bottom link_Wrap'
                      // style={{ top: "80px" }}
                    >
                      <p
                        className='btn_link text_drak'
                        style={{
                          textDecoration: 'none',
                          color: '4A4540',
                          textTransform: 'capitalize',
                        }}
                      >
                        <b>{`${userInfo.firstName} ${userInfo.lastName}`}</b> |{' '}
                        {userInfo.university}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <RightsidebarGreybox className={'abs_gray_cols'} />
            </div>
          </div>
        </section>
      </div>
      {/* <!-- Modal --> */}
      <>
        {/* Your other content here... */}
        <Modal
          show={modalShow}
          onHide={handleClose}
          backdrop='static'
          className='modal fade custom_modal_not model_with'
          id='Not_yet'
          tabIndex='-1'
          aria-labelledby='Not_yetLabel'
          aria-hidden='true'
        >
          <div className='modal-width'>
            <ModalBody>
              <button
                onClick={handleClose}
                type='button'
                className='btn_close_modal'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <img src='/assets/images/cross.png' alt='cross' />
              </button>
              <div className='modal-body modal_content_main_Wrap'>
                <div className='modal_content_box' style={{ marginLeft: '0px' }}>
                  <h1>not yet!</h1>
                  <p>Complete new class creation to invite students to your virtual classroom.</p>
                </div>
                <div className='btn_wrap_info' style={{ marginTop: '40px' }}>
                  {/* Customize the onClick event for this button */}
                  <button type='button' className='btn_black_theme' onClick={handleClose}>
                    Take me back to class creation
                  </button>
                  <button
                    type='button'
                    className='btn_outline_dark mt_24'
                    onClick={() => navigate('/dashboard')}
                  >
                    Return to my Dashboard
                  </button>
                </div>
              </div>
            </ModalBody>
          </div>
        </Modal>
      </>
    </div>
  );
};
function SectionClass({
  id2,
  item,
  emailsMap,
  dispatch,
  values,
  loading,
  setLoading,
  creatSection,
  setCreatSection,
  setShow,
  show,
  setCreateLink,
}) {
  // eslint-disable-next-line no-unused-vars
  const [isDeleteConform, setIsDeleteConform] = useState(true);
  const [showEamailSearch, setShowEamailSearch] = useState(null);
  const emails = useSelector((state) => state.entities.instructors.instructors) || [];
  const [errorMessage1] = useState({
    type: 'success',
    message: '',
  });

  //// Formik for Update Section
  const onSubmit = (values, action) => {
    dispatch(
      sectionUpdate({
        id: item._id,
        body: {
          sectionName: values.sectionName,
          sectionNumber: values.sectionNumber,
          instructorEmails: values.instructorEmails,
        },

        onSuccess: (res) => {
          setShow(false);
          setCreateLink(true);
          setLoading(false);
        },

        onError: (err) => {},
      })
    );
  };
  const sectionName =
    item.sectionName.length > 8 ? item.sectionName.slice(0, 8) + '...' : item.sectionName;

  const sectionNum = item.sectionNumber.split('-')[0];
  const truncatedSectionNum = sectionNum.length > 6 ? sectionNum.slice(0, 6) + '...' : sectionNum;

  return (
    <div>
      {!show && (
        <div className='deatils_section_info create_class-width' key={item.id}>
          <ul>
            <li style={{ textDecoration: 'capitalize' }}>{sectionName}</li>
            <li>| Section</li>
            <li>{truncatedSectionNum}</li>
            <li>|</li>
            <li>
              {item.instructorEmails && item.instructorEmails.length > 0 && (
                <>
                  <b>
                    {(() => {
                      const emailObj = item.instructorEmails[0];
                      const mappedUser = emailsMap[emailObj.email];
                      const name = mappedUser
                        ? `${mappedUser.firstName} ${mappedUser.lastName}`
                        : emailObj.email.split('@')[0];

                      const truncatedName = name.length > 15 ? name.slice(0, 15) + '...' : name;
                      return truncatedName;
                    })()}
                  </b>

                  {item.instructorEmails.length > 1 && (
                    <b>
                      {' '}
                      +{item.instructorEmails.length - 1}{' '}
                      {!isDeleteConform
                        ? ''
                        : `instructor${item.instructorEmails.length - 1 > 1 ? 's' : ''}`}
                    </b>
                  )}
                </>
              )}
            </li>
          </ul>

          <div className='edite_option'>
            {isDeleteConform ? (
              <>
                <a>
                  {' '}
                  <img
                    src={edit}
                    alt='pluse'
                    className='edit mr-2'
                    onClick={() => {
                      setShow(true);
                      setCreateLink(false);
                    }}
                  />{' '}
                </a>
                <a>
                  {' '}
                  <img
                    alt='pluse'
                    src={delet}
                    className='edit'
                    onClick={() => {
                      setIsDeleteConform(false);
                    }}
                  />
                </a>
              </>
            ) : (
              <>
                <a>
                  {' '}
                  <img
                    src={tick}
                    alt='delete section'
                    className='edit mr-2'
                    onClick={() => {
                      dispatch(
                        deleteSection({
                          id: item._id,
                          onSuccess: (res) => {
                            const { _id, classId } = res?.data?.data; // Extract sectionId and classId from API response

                            dispatch(removeSection(_id)); // Use API response data
                            dispatch(
                              deleteSectionsidebar({
                                sectionId: _id,
                                classId: classId,
                              })
                            ); // Use API response data

                            setIsDeleteConform(true);
                          },
                        })
                      );
                    }}
                  />{' '}
                </a>
                <a>
                  {' '}
                  <img
                    alt='cancel delete'
                    src={cross}
                    className='edit'
                    onClick={() => {
                      setIsDeleteConform(true);
                    }}
                  />{' '}
                </a>
              </>
            )}
            <></>
          </div>
        </div>
      )}
      {show && (
        <Formik
          initialValues={{
            sectionName: item.sectionName,
            sectionNumber: item.sectionNumber.split('-')[0],
            instructorEmails: item.instructorEmails.map(({ email }) => email),
          }}
          validationSchema={classDetailsValiation}
          onSubmit={onSubmit}
        >
          {({ values, errors, setFieldValue, handleBlur, handleSubmit, handleChange }) => {
            let selectedEmailsMap = {};
            for (const email of values.instructorEmails) {
              selectedEmailsMap[email] = true;
            }
            return (
              <div className='update-section' style={{ width: '768px' }}>
                <form className='App-form' onSubmit={handleSubmit}>
                  <div className='row'>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Section Name'
                          name='sectionName'
                          value={values.sectionName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          autoComplete='off'
                        />{' '}
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Section number'
                          name='sectionNumber'
                          value={values.sectionNumber}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          autoComplete='off'
                        />{' '}
                      </div>
                    </div>

                    <div className='col-md-12'>
                      <div
                        className='form-group email_seaech_wrap'
                        style={{ paddingBottom: '10px' }}
                      >
                        <InstructorEmails
                          values={values}
                          errors={errors}
                          emails={emails}
                          emailsMap={emailsMap}
                          setFieldValue={setFieldValue}
                          errorMessage1={errorMessage1}
                          showEamailSearch={showEamailSearch}
                          setShowEamailSearch={setShowEamailSearch}
                          selectedEmailsMap={selectedEmailsMap}
                        />

                        <div className='btn_Wrap mt-30'>
                          <button
                            type='submit'
                            className='btn_black_theme w-100 d-block'
                            disabled={loading ? true : false}
                          >
                            {loading ? (
                              <div className='loader'>
                                <Loader />
                              </div>
                            ) : (
                              'Update section to class'
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>{' '}
                </form>
              </div>
            );
          }}
        </Formik>
      )}
    </div>
  );
}
function InstructorEmails({
  values,
  errors,
  emails,
  emailsMap,
  setFieldValue,
  errorMessage1,
  showEamailSearch,
  selectedEmailsMap,
  setShowEamailSearch,
}) {
  const selectedEmailsCountMap = values.instructorEmails.reduce((acc, curr) => {
    acc[curr] = (acc[curr] || 0) + 1;
    return acc;
  }, {});

  return (
    <div>
      <FieldArray
        name='instructorEmails'
        render={({ push }) => (
          <div>
            {values.instructorEmails &&
              values.instructorEmails.length > 0 &&
              values.instructorEmails.map((instructorEmails, index) => (
                <div
                  key={index}
                  className='form-group email_seaech_wrap'
                  style={{ paddingBottom: '10px' }}
                >
                  <Field name={`instructorEmails.${index}`}>
                    {({ field, form: { touched, errors }, meta }) => {
                      const filteredEmails = emails.filter((item) => {
                        return selectedEmailsMap[item.email]
                          ? false
                          : item.email.includes(field.value);
                      });
                      const error =
                        meta.error && meta.touched
                          ? errors.instructorEmails === '*'
                            ? 'Required*'
                            : errors.instructorEmails === 'unique'
                            ? selectedEmailsCountMap[field.value] > 1
                              ? 'Only unique email allowed.'
                              : ''
                            : errors.instructorEmails[index]
                          : '';

                      return (
                        <div style={{ position: 'relative' }}>
                          <EmailData
                            instructor={emailsMap[field.value]}
                            onRemove={() => setFieldValue(field.name, '')}
                          />

                          <input
                            {...field}
                            type='email'
                            className='form-control'
                            placeholder='Enter instructor email'
                            autoComplete='off'
                            onBlur={(e) => {
                              field.onBlur(e);
                              setTimeout(() => setShowEamailSearch(null), 300);
                            }}
                            onFocus={() => setTimeout(() => setShowEamailSearch(index), 300)}
                          />

                          {meta.error && meta.touched && <InstructorEmailError error={error} />}

                          {index === 0 &&
                            (!field.value || (meta.error && !error.includes('unique'))) && (
                              <p className='invite-email' style={{ marginBottom: '0px' }}>
                                *We’ll send the instructor an email inviting them to join Greyled
                              </p>
                            )}
                          {field.value && field.value.length > 3 && (
                            <Suggestions
                              index={index}
                              setFieldValue={setFieldValue}
                              filteredEmails={filteredEmails}
                              showEamailSearch={showEamailSearch}
                              setShowEamailSearch={setShowEamailSearch}
                            />
                          )}
                        </div>
                      );
                    }}
                  </Field>
                </div>
              ))}

            {!errors.instructorEmails &&
              values.instructorEmails.filter((email) => email === '').length === 0 && (
                <p className='text_info'>
                  <a className='btn btn-linke p-0' onClick={() => push('')}>
                    + Add additional instructors
                  </a>
                </p>
              )}

            <div className='backend-error'>
              {errorMessage1.message && (
                <div className={`alert alert-${errorMessage1.type}`}>{errorMessage1.message}</div>
              )}
            </div>
          </div>
        )}
      />
    </div>
  );
}

function InstructorEmailError({ error }) {
  return (
    <>
      {error && (
        <div
          style={{
            fontSize: '12px',
            color: '#ae2604',
            marginBottom: '10px',
            marginTop: '0.8%',
          }}
        >
          {error}
        </div>
      )}
    </>
  );
}

function Suggestions({
  index,
  setFieldValue,
  filteredEmails,
  showEamailSearch,
  setShowEamailSearch,
}) {
  return (
    <>
      {showEamailSearch === index && filteredEmails.length > 0 && (
        <div className='user-list'>
          <div className='email_seaech Schedule_box create_box'>
            <div className='email_text'>
              {filteredEmails.map((item) => (
                <ul key={item.email}>
                  <li
                    onClick={() => {
                      setFieldValue(`instructorEmails.${index}`, item.email);
                      setShowEamailSearch(null);
                    }}
                  >
                    <span className='email_dynamic'>{item.email}</span>
                    <span>
                      {item.firstName} <> </>
                      {item.lastName}| {item.university}
                    </span>
                  </li>
                </ul>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function EmailData({ instructor, onRemove }) {
  if (!instructor) return '';

  const { firstName, lastName, university } = instructor;

  return (
    <div
      style={{
        position: 'absolute',
        top: '10px',
        right: ' -30px',
      }}
    >
      <span style={{ marginRight: '10px' }}>
        {firstName} {lastName} | {university}
      </span>
      <img src={cross} alt='pluse' className='cursor' onClick={() => onRemove()} />
    </div>
  );
}

export default CreateClass;
